import { Link, styled } from "@mui/material";
import { FONT_COLORS } from "../../../../constants";

const TitleWithEllipsis = styled(Link)(() => ({
  display: "-webkit-box",
  overflow: "hidden",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  textOverflow: "ellipsis",
  fontSize: 12,
  fontWeight: 700,
  cursor: "pointer",
  color: FONT_COLORS.default,

  "&:hover": {
    color: FONT_COLORS.info,
  },
}));

export default TitleWithEllipsis;
